import {
  NOTIFICATION_SOUND_PATH,
  NOTIFICATION_SOUND_REPEAT_INTERVAL_MS,
} from "../constants/notifications.constants";

const BASE = typeof import.meta.env.BASE_URL === "string" ? import.meta.env.BASE_URL : "";
const NOTIFICATION_SOUND_URL = `${BASE.replace(/\/$/, "")}${NOTIFICATION_SOUND_PATH}`;

let repeatIntervalId: ReturnType<typeof setInterval> | null = null;

export function playNotificationSound(): void {
  try {
    const audio = new Audio(NOTIFICATION_SOUND_URL);
    const played = audio.play();
    if (played !== undefined) {
      played.catch(() => {
        // Browser autoplay policy or file not found
      });
    }
  } catch {
    // Ignore if Audio is not available or fails
  }
}

export function startNotificationSoundLoop(): void {
  stopNotificationSoundLoop();
  repeatIntervalId = setInterval(() => {
    playNotificationSound();
  }, NOTIFICATION_SOUND_REPEAT_INTERVAL_MS);
}

export function stopNotificationSoundLoop(): void {
  if (repeatIntervalId !== null) {
    clearInterval(repeatIntervalId);
    repeatIntervalId = null;
  }
}
